<ion-button [color]="color" expand="block" [fill]="fill" (click)="goToForm()" [disabled]="to.disabled">{{label}}</ion-button>